import get from 'lodash/get'
import has from 'lodash/has'
import set from 'lodash/set'

import MigrationShouldRun from 'api/migrate/MigrationShouldRun'
import UpdateVersion from 'api/migrate/UpdateVersion'

/**
 * Run the migration if version is less than the config.
 *
 * @param {Object} config
 */
export default function (config) {
  const MIGRATION_TO_VERSION = 3

  if (MigrationShouldRun(config, MIGRATION_TO_VERSION)) {
    // Run migration scripts here...
    config = replaceSiteURLInConfig(config, 'layout.drawer.tabs.tools.annotations.upgrade.url')
    config = replaceSiteURLInConfig(config, 'layout.drawer.tabs.tools.login.upgrade.url')
    config = replaceSiteURLInConfig(config, 'layout.drawer.tabs.tools.share.upgrade.url')
    config = replaceSiteURLInConfig(config, 'layout.drawer.tabs.tools.downloadgroup.upgrade.url')
    config = replaceSiteURLInConfig(config, 'layout.drawer.tabs.tools.measuregroup.upgrade.url')
    config = replaceSiteURLInConfig(config, 'layout.drawer.tabs.tools.selectgroup.upgrade.url')
    config = replaceSiteURLInConfig(config, 'layout.drawer.tabs.about.panels.support.poziSupportURL')
    UpdateVersion(config, MIGRATION_TO_VERSION)
  }
  return config
}

function replaceSiteURLInConfig (config, path) {
  let url = ''
  if (has(config, path)) {
    url = get(config, path, '')
    if (url.indexOf('https://www.groundtruth.com.au/post/love-your-internal-gis-pozi-will-integrate') !== -1) {
      url = 'https://pozi.com/love-your-internal-gis-thats-great-pozi-will-integrate-with-it/'
    } else if (url.indexOf('www.groundtruth.com.au') !== -1) {
      url = url.replace('www.groundtruth.com.au', 'pozi.com')
    } else if (url.indexOf('groundtruth.com.au') !== -1) {
      url = url.replace('groundtruth.com.au', 'pozi.com')
    }

    // poziSupportURL
    set(config, path, url)
  }
  return config
}
